<script setup lang="ts">

import { comma, currency } from "@library/Utilities";
import type { ICarbucksProfile } from "@domain/Carbucks";
import SpinningCoin from "./SpinningCoin.vue";

const model = defineModel<ICarbucksProfile>( { required: true } );

const progressBarWidth = calculateProgressBarSize();

function calculateProgressBarSize()
{
    const numerator = Math.min( model.value.MinimumCarbucksBeforeRedemption, Math.max( 1, model.value.availableAmount ) );

    return Math.round( ( numerator / model.value.MinimumCarbucksBeforeRedemption ) * 100 );
}

</script>

<template>
    <div class="flex flex-col items-center w-full mb-3">
        <h2 class="my-2 text-4xl lg:text-5xl font-extrabold flex items-center
                    text-primary-500 dark:text-white">
            <!-- <SpinningCoin :spin="false" class="!h-[64px] !w-[64px] mr-3" /> -->
            <span class="opacity-80">$</span>{{ comma( model.availableAmount, 2 ) }}
        </h2>
    </div>
    <div class="w-80 mx-auto text-center">
        <div class="rounded overflow-hidden relative">
            <div class="bg-gray-200 h-2 w-full"></div>
            <div class="absolute bg-secondary h-2 top-0 left-0 rounded-r" :style="{ width: `${progressBarWidth}%` }"></div>
        </div>
        <div class="text-xs 3xl:text-base px-3 mt-3 text-gray-400">Withdraw or save for your next car expense, it’s up to you. Min balance of {{ currency( model.MinimumCarbucksBeforeRedemption, undefined, false ) }} required.</div>
    </div>
</template>